module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Franklin W. Dixon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Franklin W. Dixon is the pen name used by a variety of different authors (Charles Leslie McFarlane, a Canadian author, being the first) who wrote The Hardy Boys novels. ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pe2mCg/tc-custom/9781439114292.jpg?1730538477265",
      "alt": "This image is the cover for the book In Plane Sight, The Hardy Boys"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In Plane Sight, The Hardy Boys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("WILL THE HARDYS CRASH AND BURN IN THE JEWEL RIDGE AIRSHOW?")]), _c('br'), _c('br'), _vm._v("Attending an airshow to help out their friend Jamal Hawkins and his dad’s air taxi service should be a nice break from the normal grind for Frank and Joe Hardy. But when one of the Hawkinses’ planes is mysteriously stolen—starting a whole wave of crime at the event—the vacation ends, and the hunt for clues begins!"), _c('br'), _c('br'), _vm._v("The brothers’ investigation takes them from the airport runway to the nearby mountains, and even into the clouds. Who, or what, is behind the trouble? Could it be one of the exhibitors, a jealous rival, or a former hotshot pilot? The crooks’ plans are really taking off—can the Hardys ground these guys for good?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0